import { render, staticRenderFns } from "./OrderDeal.vue?vue&type=template&id=b5cf2cca&scoped=true&"
import script from "./OrderDeal.vue?vue&type=script&lang=js&"
export * from "./OrderDeal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDeal.vue?vue&type=style&index=0&id=b5cf2cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cf2cca",
  null
  
)

export default component.exports